import React from "react";
import Logo from '../assets/images/mifabLogo.png'
import '../stylesheets/finalSubmittal.scss'

const Finalsubmittal = () => {
    return (
        <section className="finalSubmittal">
           <div className="container">
               <div className="mainContent">
                   <div className="row">
                       <div className="mainContent__logo">
                           <img src={Logo} className="image-fluid"/>
                       </div>
                       
                       <div className="mainContent__textarea">
                           <h1 style={{color:'#0154A0'}}>Submittal Successful</h1>
                           <div>
                               <p>Thank You For Submittal. Please check your email address</p>
                           </div>
                       </div>
                   </div>
               </div>
           </div>
       </section>
    )
}

export default Finalsubmittal